<template>
	<div
		class="spansTable__item"
		:class="{
			'is-checkable': canCheck,
			'is-draggable': canDrag,
			'is-deletable': canDelete,
		}"
	>
		<div class="spansTable__checkboxCell">
			<BIcon name="Dragg" class="spansTable__dragHandle" />

			<BCheckbox
				v-if="canCheck"
				class="spansTable__checkbox"
				:disabled="!canCheck"
				:label="label"
				:value="isChecked"
				@input="handleCheckChange"
				:optionValue="spanItem"
			/>

			<div v-else class="spansTable__label">{{ label }}</div>
		</div>

		<BFieldNumber
			v-model="spanItem.size"
			:min="0.01"
			suffix="m"
			:step="0.01"
			:precision="2"
			size="s/m"
			class="spansTable__field"
		/>

		<BBtn
			class="spansTable__deleteSpanBtn"
			size="s/m"
			color="secondary"
			shape="circle"
			:disabled="!canDelete"
			@click="() => handleDeleteClick(spanItem)"
		>
			<BIcon name="Delete" size="20px" />
		</BBtn>
	</div>
</template>

<script>
import BCheckbox from "@/components/base/BCheckbox.vue";
import BFieldNumber from "@/components/base/BFieldNumber.vue";
import BBtn from "@/components/base/BBtn.vue";
import BIcon from "@/components/base/BIcon/index.vue";

export default {
	props: {
		spanItem: {
			type: Object,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		isChecked: {
			type: Boolean,
			default: false,
		},
		checkedModel: {
			type: Array,
		},
		canDelete: {
			type: Boolean,
			default: true,
		},
		canCheck: {
			type: Boolean,
			default: true,
		},
		canDrag: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		BCheckbox,
		BFieldNumber,
		BBtn,
		BIcon,
	},
	methods: {
		handleCheckChange(checked) {
			this.$emit("check", this.spanItem, checked);
		},
		handleDeleteClick() {
			this.$emit("delete", this.spanItem);
		},
	},
};
</script>
